import cx from 'classnames';
import { t } from 'i18next';
import { commonRoutes } from '../../../gameConfig/commonRoutes';
import { withSiteMeta } from '../../HOCS/withSiteMeta';
import { navigateToWithPageRefresh } from '../../libs/history';
import { doLogin, getLoginUrls } from '../../libs/login';
import { Link } from '../link';
import { FC } from 'react';

export const MainNavLoginButton: FC<any> = (props) => {
  return (
    <div
      className={cx(
        props.className,
        'd-inline-block rio-auth-nav__button rio-auth-nav__button--hollow rio-pointer text-nowrap text-bold'
      )}
      onClick={(e) => {
        e.preventDefault();
        doLogin();
      }}
    >
      {t('nav:auth.login')}
    </div>
  );
};

export const MainNavSignupButton: FC<any> = (props) => {
  const { mainLoginUrl } = getLoginUrls();

  return (
    <Link
      className={cx(props.className, 'rio-auth-nav__button rio-auth-nav__button--brand text-nowrap text-bold')}
      to={`${mainLoginUrl}${commonRoutes.Register}`}
    >
      {t('nav:auth.signup')}
    </Link>
  );
};

function refreshBattleNet() {
  navigateToWithPageRefresh(`/battlenet/authorize?redirect=${encodeURIComponent(window.location.pathname)}`);
  RIO_TRACK_EVENT('event', 'refresh_bnet_authbar');
}

const MainNavRefreshBnetButtonBase: FC<any> = (props) => {
  const { auth } = props;
  if (!auth || !auth.bnet_resync_needed) {
    return null;
  }

  return (
    <button
      className={cx(props.className, 'slds-button slds-button--neutral text-white fade-in')}
      onClick={refreshBattleNet}
    >
      <span className="slds-avatar slds-avatar--small slds-m-right--xx-small rio-profile-links battlenet text-bold" />
      {t('nav:auth.refresh-bnet')}
    </button>
  );
};

export const MainNavRefreshBnetButton = withSiteMeta(MainNavRefreshBnetButtonBase);
